/* eslint-disable no-unused-vars */
import React from 'react';

export const OrderConsoleContext = React.createContext({
  order: undefined,
  setOrder: order => {},
  includeTax: true,
  setIncludeTax: includeTax => {},
  failures: undefined,
  setFailures: failures => {},
  stateChangeEvents: undefined,
  setStateChangeEvents: stateChangeEvents => {},
});
